import { navIndexReducer as navIndex } from './navModel';
import { navTreeReducer as navBarTree } from './navBarTree';
import { appNotificationsReducer as appNotifications } from './appNotification';

export default {
  navBarTree,
  navIndex,
  appNotifications,
};
